import type { PageBackgroundColorType } from "./types";

export const defaultPageBackgroundColorData: PageBackgroundColorType = {
  // eslint-disable-next-line local/no-hardcoded-hex-colors
  backgroundColor: "#FFFFFF",
};
